import { render } from "./Shipment2SList.vue?vue&type=template&id=fd6ba362&scoped=true"
import script from "./Shipment2SList.vue?vue&type=script&lang=js"
export * from "./Shipment2SList.vue?vue&type=script&lang=js"

import "./Shipment2SList.vue?vue&type=style&index=0&id=fd6ba362&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fd6ba362"

export default script